module.exports = __webpack_public_path__ + "img/deschutes-brewery.aaa1ca2f.jpeg";